module.exports = __webpack_public_path__ + "img/chat-square-dots.38a4f5fe.svg";